import React, {Component} from "react"
import PropTypes from "prop-types"
import {injectIntl} from "@irati/utils/lang"
import PermissionOption from "./index"

class RewardPermission extends Component {
  static propTypes = {
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {
    id: "recognitionRewardPermissionFieldId",
    name: "recognitionSharing",
    action: "attachReward"
  }

  render() {
    const {intl, ...props} = this.props
    return <PermissionOption
      {...props}
      title={intl.formatMessage({id: "admin.recognitionSharing.title"})}
      label={intl.formatMessage({id: "admin.recognitionSharing.label"})}
      description={intl.formatMessage({id: "admin.recognitionSharing.desc"})}
      placeholder={intl.formatMessage({id: "admin.recognitionSharing.placeholder"})} />
  }
}

export default injectIntl(RewardPermission)
